import { h } from 'preact';
import { Locations, TravelClass, TravelType, WidgetTab } from '../../../common';
import { Modal, ModalBody, ModalHeader, ModalProps, ModalTitle } from '../../../modal';
import * as appStyles from '../../../assets/global.scss';
import { Actions, actions, BookingState, CompactWidgetState, connectWithStyles } from '../../../store';
import { WithStyles } from '../../../style';
import TravelTypeRadio from '../TravelTypeRadio/TravelTypeRadio';
import { FinText } from '../../../i18n';

const allTravelClasses: TravelClass[] = [
  TravelClass.MIXED,
  TravelClass.ECONOMY,
  TravelClass.PREMIUM_ECONOMY,
  TravelClass.BUSINESS,
];

export interface TravelTypeModalProps extends ModalProps {}

interface StoreProps {
  travelType: TravelType;
  travelClasses: TravelClass[];
  currentTab: WidgetTab;
  locations: Locations[];
  compactWidgetState: CompactWidgetState;
  enableOpenJaw: boolean;
}

type EffectiveProps = TravelTypeModalProps & StoreProps & WithStyles & Actions;

const mapStateToProps = ({
  selection: { travelType, locations },
  amState: { amSelection },
  ux: { travelClasses, compactWidgetState },
  currentTab,
  enableOpenJaw,
}: BookingState): StoreProps => ({
  travelType: currentTab === WidgetTab.AM ? amSelection.travelType : travelType,
  travelClasses: currentTab === WidgetTab.AM ? allTravelClasses : travelClasses,
  currentTab,
  locations,
  compactWidgetState,
  enableOpenJaw,
});

const renderRadioElements = (selected: TravelType, travelTypes: TravelType[], updateTravelType) => {
  return travelTypes.map((travelType, i) => (
    <TravelTypeRadio
      key={travelType}
      class={i < travelTypes.length - 1 ? 'border-bottom' : ''}
      value={travelType}
      checked={selected === travelType}
      selected={false}
      onSelection={updateTravelType}
    />
  ));
};

export const TravelTypeModal = connectWithStyles<TravelTypeModalProps>([appStyles], { mapStateToProps, actions })(
  ({ travelType, setTravelType, enableOpenJaw, currentTab, tx }: EffectiveProps) => {
    const updateTravelType = (newTravelType: TravelType) => {
      setTravelType(newTravelType);
    };

    const availableTravelTypes = [
      TravelType.ROUND_TRIP,
      TravelType.ONE_WAY,
      enableOpenJaw && currentTab === WidgetTab.FLIGHT ? TravelType.MULTI_CITY : null,
    ].filter(Boolean);

    return (
      <Modal class="bw-travel-class-modal">
        <ModalHeader>
          <ModalTitle>
            <FinText id="travelType.label" />
          </ModalTitle>
        </ModalHeader>
        <ModalBody class={tx('ps-large-x')}>
          {renderRadioElements(travelType, availableTravelTypes, updateTravelType)}
        </ModalBody>
      </Modal>
    );
  }
);
